import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/data';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-8 h-px bg-accent-400/60"></span>
            <span className="text-accent-600 text-sm tracking-widest font-label uppercase">
              精选推荐
            </span>
            <span className="w-8 h-px bg-accent-400/60"></span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门内容
          </h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-md mx-auto">
            精选官方高质量内容，为你呈现琉璃神社最新鲜的资讯与资源
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={`${article.title} - 琉璃神社官方`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                {article.isPinned && (
                  <span className="absolute top-3 left-3 bg-primary-500 text-white text-xs px-2 py-0.5 rounded-md font-medium">
                    置顶
                  </span>
                )}
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full font-medium">
                    {article.tags[0]}
                  </span>
                  <span className="text-xs text-foreground-400">{article.publishDate}</span>
                </div>
                <h3 className="font-heading font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors text-sm leading-snug line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}